import { Injectable } from '@angular/core';
import {
    AccountMappingTemplateGroupItem,
    IAccountMappingTemplate,
    IAccountMappingTemplateGroup,
    IAccountMappingTemplateGroupItemFLI,
    ItemType,
} from '@modeso/types__aumico-lib-annualreport-be';
import { cloneDeep } from 'lodash-es';
import { NumberUtils } from '../../../../../../aumico-lib-core-fe/src/lib';

@Injectable({ providedIn: 'root' })
export class CashFlowStatementMapper {
    private flisOfItems: IAccountMappingTemplateGroupItemFLI[];

    getTemplateFlis(template: IAccountMappingTemplate): IAccountMappingTemplateGroupItemFLI[] {
        const flisOfGroups: IAccountMappingTemplateGroupItemFLI[] = [];

        const templateGroups: IAccountMappingTemplateGroup[] = [template.group];

        flisOfGroups.push(...this.getFlisOfGroups(templateGroups));

        return flisOfGroups;
    }

    private getFlisOfGroups(templateGroups: IAccountMappingTemplateGroup[]): IAccountMappingTemplateGroupItemFLI[] {
        const flisOfGroups: IAccountMappingTemplateGroupItemFLI[] = [];
        for (const group of templateGroups) {
            const flisOfCurrentGroup: IAccountMappingTemplateGroupItemFLI[] = this.extractFLIAndAccounts(group.items);

            flisOfGroups.push(...flisOfCurrentGroup);

            if (group.groups && group.groups.length > 0) {
                flisOfGroups.push(...this.getFlisOfGroups(group.groups));
            }
        }

        return flisOfGroups;
    }

    private extractFLIAndAccounts(
        itemsOfGroup: AccountMappingTemplateGroupItem[],
    ): IAccountMappingTemplateGroupItemFLI[] {
        this.flisOfItems = [];
        for (const item of itemsOfGroup) {
            if (item.type === ItemType.FLI) {
                const fli: IAccountMappingTemplateGroupItemFLI = cloneDeep<IAccountMappingTemplateGroupItemFLI>(item);

                if (item.calculatedClosingBalance != null && NumberUtils.isFinite(item.calculatedClosingBalance)) {
                    fli.calculatedClosingBalance = NumberUtils.roundNumber(item.calculatedClosingBalance);
                }

                if (item.calculatedOpeningBalance != null && NumberUtils.isFinite(item.calculatedOpeningBalance)) {
                    fli.calculatedOpeningBalance = NumberUtils.roundNumber(item.calculatedOpeningBalance);
                }

                this.flisOfItems.push(fli);
            }
        }

        return this.flisOfItems;
    }
}
